import React, { useEffect, useState } from 'react';
import {
  Box,
  BoxProps,
  ComponentWithAs,
  Flex,
  FlexProps,
  forwardRef,
  Heading,
  Text,
  useToast,
} from '@chakra-ui/react';
import { excludeCategories } from '../../../atoms/chooseState';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Category } from '../../../type';
import { motion, MotionProps } from 'framer-motion';
import { categories } from '../../../constants/category';

const MotionBox = motion<BoxProps>(Box);
const MotionFlex = motion<FlexProps>(Flex);

type CategoryProps = {
  category: Category;
};

const FoodCategory: ComponentWithAs<'div', MotionProps & BoxProps & CategoryProps> = forwardRef<
  MotionProps & BoxProps & CategoryProps,
  'div'
>((props, ref) => {
  const category = props.category;
  const setExcludeList = useSetRecoilState(excludeCategories);
  const excludeList = useRecoilValue(excludeCategories);
  const [clicked, setClicked] = useState(excludeList.has(category.name));
  const toast = useToast();

  const onClick = () => {
    setClicked(!clicked);
  };

  useEffect(() => {
    if (clicked) {
      setExcludeList((oldExcludeList) => {
        if (!oldExcludeList.has(category.name) && oldExcludeList.size + 1 >= Object.keys(categories).length) {
          toast({
            title: '카테고리 제외 불가',
            description: '모든 카테고리를 제외할 수 없습니다. 다른 카테고리를 선택해 주세요.',
            position: 'top',
            status: 'error',
            duration: 2000,
            isClosable: false,
          });
          setClicked(!clicked);
        } else {
          oldExcludeList.add(category.name);
        }
        return oldExcludeList;
      });
    } else {
      const setExcludeLists = excludeList;
      setExcludeLists.delete(category.name);
      setExcludeList(setExcludeLists);
    }
  }, [clicked]);

  return (
    <MotionBox
      as='button'
      width='25vw'
      height='25vw'
      maxW={32}
      maxH={32}
      animate={{
        transform: clicked ? 'scale(0.8)' : 'scale(1.0)',
      }}
      onClick={onClick}
      ref={ref}
      {...props}
    >
      <MotionFlex
        direction='column'
        justifyContent='center'
        alignItems='center'
        bg='grayBackground'
        width='100%'
        height='100%'
        animate={{
          filter: clicked ? 'grayScale(100%)' : 'grayScale(0%)',
        }}
        cursor='pointer'
        borderRadius={'lg'}
      >
        <Heading fontSize='2em'>{category.emoji}</Heading>
        <Text fontSize={['xs', 'lg']} align='center' isTruncated>
          {category.name}
        </Text>
      </MotionFlex>
    </MotionBox>
  );
});

export default FoodCategory;
